var _this = this;
import * as tslib_1 from "tslib";
import { googleGeoCoderActionTypes } from './ActionTypes';
import { GoogleGeoCoderResponse } from '../../../globalTypes';
import { GoogleGeoCoder } from '../../util/GoogleGeoCoder/GoogleGeoCoder';
export var getGoogleGeoCoderResponse = function (googleGeoCoderStateRequest) {
    return function (dispatch) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
        var googleGeoCoderResponse, googleGeoCoder, error_1;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    googleGeoCoderResponse = new GoogleGeoCoderResponse('NO', googleGeoCoderStateRequest.name);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    googleGeoCoder = GoogleGeoCoder.getInstance();
                    return [4 /*yield*/, googleGeoCoder.encode(googleGeoCoderStateRequest.country, googleGeoCoderStateRequest.postcode, googleGeoCoderStateRequest.name)];
                case 2:
                    googleGeoCoderResponse = _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    return [2 /*return*/, dispatch({
                            type: googleGeoCoderActionTypes.RECEIVE_GEOCODER_FAILED
                        })];
                case 4: return [2 /*return*/, dispatch({
                        type: googleGeoCoderActionTypes.RECEIVE_GOOGLE_GEO_CODER_STATE,
                        googleGeoCoderResponse: googleGeoCoderResponse
                    })];
            }
        });
    }); };
};
